"use client"

import { useEffect, useState } from "react"
import Link from "next/link"
import { services } from "@/app/content/landing"
import { Container } from "@/app/components/container"
import { CloseIcon, MenuIcon } from "@/app/components/icons"
import { primaryButtonClass } from "@/app/components/styles"

const pageLinks = [
  { href: "/#cases", label: "Кейсы" },
  { href: "/#about", label: "О студии" },
]

export function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false)
  const [servicesOpen, setServicesOpen] = useState(false)

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : ""
    return () => {
      document.body.style.overflow = ""
    }
  }, [menuOpen])

  useEffect(() => {
    function onKeyDown(event: KeyboardEvent) {
      if (event.key === "Escape") {
        setMenuOpen(false)
        setServicesOpen(false)
      }
    }

    window.addEventListener("keydown", onKeyDown)
    return () => window.removeEventListener("keydown", onKeyDown)
  }, [])

  function closeMenu() {
    setMenuOpen(false)
    setServicesOpen(false)
  }

  return (
    <>
    <header className="sticky top-0 z-50 border-b border-line bg-white/95 backdrop-blur">
      <Container className="flex h-16 items-center justify-between gap-4">
        <Link href="/#top" className="text-xl font-semibold tracking-tight" onClick={closeMenu}>
          V8<span className="text-accent">›</span>
        </Link>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Основная навигация">
          <Link href="/#cases" className="text-sm font-medium text-foreground/80 hover:text-foreground">
            Кейсы
          </Link>
          <div
            className="relative"
            onMouseEnter={() => setServicesOpen(true)}
            onMouseLeave={() => setServicesOpen(false)}
          >
            <button
              type="button"
              className="cursor-pointer text-sm font-medium text-foreground/80 hover:text-foreground"
              aria-expanded={servicesOpen}
              aria-controls="services-menu"
              onClick={(event) => {
                if (event.detail === 0) {
                  setServicesOpen((open) => !open)
                  return
                }
                setServicesOpen(true)
              }}
            >
              Услуги
            </button>
            {servicesOpen ? (
              <div
                id="services-menu"
                className="absolute top-full left-1/2 z-10 w-64 -translate-x-1/2 pt-3"
              >
                <ul className="rounded-2xl bg-white p-2 shadow-xl ring-1 ring-line">
                  {services.map((service) => (
                    <li key={service.id}>
                      <Link
                        href={`/#${service.id}`}
                        className="block rounded-xl px-3 py-2.5 text-sm font-medium hover:bg-surface"
                        onClick={() => setServicesOpen(false)}
                      >
                        {service.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
          </div>
          <Link href="/#about" className="text-sm font-medium text-foreground/80 hover:text-foreground">
            О студии
          </Link>
        </nav>

        <div className="flex items-center gap-2">
          <Link
            href="/#contact"
            className="hidden h-12 items-center justify-center rounded-full bg-accent px-5 text-sm font-medium text-white transition-colors hover:bg-accent-strong sm:inline-flex"
          >
            Обсудить проект
          </Link>
          <button
            type="button"
            className="inline-flex size-12 cursor-pointer items-center justify-center rounded-full bg-accent text-white lg:hidden"
            aria-expanded={menuOpen}
            aria-controls="mobile-menu"
            onClick={() => setMenuOpen((open) => !open)}
          >
            {menuOpen ? <CloseIcon /> : <MenuIcon />}
            <span className="sr-only">{menuOpen ? "Закрыть меню" : "Открыть меню"}</span>
          </button>
        </div>
      </Container>
    </header>

      {menuOpen ? (
        <div id="mobile-menu" className="fixed inset-x-0 top-16 bottom-0 z-40 overflow-y-auto bg-white lg:hidden">
          <nav className="flex flex-col gap-1 px-5 py-6" aria-label="Мобильная навигация">
            <Link
              href="/#cases"
              className="rounded-2xl px-3 py-3 text-lg font-medium hover:bg-surface"
              onClick={closeMenu}
            >
              Кейсы
            </Link>
            <p className="px-3 pt-2 text-sm font-medium text-muted">Услуги</p>
            {services.map((service) => (
              <Link
                key={service.id}
                href={`/#${service.id}`}
                className="rounded-2xl px-3 py-3 text-lg font-medium hover:bg-surface"
                onClick={closeMenu}
              >
                {service.title}
              </Link>
            ))}
            {pageLinks.slice(1).map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className="rounded-2xl px-3 py-3 text-lg font-medium hover:bg-surface"
                onClick={closeMenu}
              >
                {link.label}
              </Link>
            ))}
            <Link href="/#contact" className={`${primaryButtonClass} mt-4`} onClick={closeMenu}>
              Обсудить проект
            </Link>
            <Link
              href="/privacy"
              className="mt-3 px-3 py-2 text-sm text-muted hover:text-foreground"
              onClick={closeMenu}
            >
              Политика конфиденциальности
            </Link>
            <Link
              href="/oferta"
              className="px-3 py-2 text-sm text-muted hover:text-foreground"
              onClick={closeMenu}
            >
              Публичная оферта
            </Link>
          </nav>
        </div>
      ) : null}
    </>
  )
}
